import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { AppInsightsService } from './app-insights.service';
import { LogStorageService } from './log-storage.service';

export type ILogFn = (msg: string, data?: unknown, source?: string, showToast?: boolean) => void;

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  constructor(
    private appInsightsService: AppInsightsService,
    private snackBar: MatSnackBar,
    private logStorageService: LogStorageService
  ) {}

  getLogFn(moduleId: string, fnName?: string): ILogFn {
    fnName = fnName ?? 'log';
    switch (fnName.toLowerCase()) {
      // convert aliases
      case 'success':
        fnName = 'logSuccess';
        break;
      case 'error':
        fnName = 'logError';
        break;
      case 'warn':
        fnName = 'logWarning';
        break;
      case 'warning':
        fnName = 'logWarning';
        break;
    }

    const logFn = (this as unknown as Record<string, ILogFn>)[fnName] || this.log;
    const fn: ILogFn = (msg: string, data?: unknown, source?: string, showToast?: boolean) => {
      logFn(msg, data, source ?? moduleId, showToast === undefined ? true : showToast);
    };
    return fn;
  }

  log = (message: string, data?: unknown, source?: string, showToast?: boolean): void => {
    this.logIt(message, data, source, showToast, 'info');
  };

  logWarning = (message: string, data?: unknown, source?: string, showToast?: boolean): void => {
    this.logIt(message, data, source, showToast, 'warning');
  };

  logSuccess = (message: string, data?: unknown, source?: string, showToast?: boolean): void => {
    this.logIt(message, data, source, showToast, 'success');
  };

  displaySuccess = (message: string, source: string, data?: unknown): void => {
    this.logIt(message, data, source, true, 'success');
  };

  logError = (message: string | Error | unknown, data?: unknown, source?: string, showToast: boolean = false): void => {
    this.logIt(message, data, source, showToast, 'error');
  };

  displayError = (message: string, source: string, data?: unknown): void => {
    this.logIt(message, data, source, true, 'error');
  };

  logIt(
    message: string | Error | unknown,
    data: unknown,
    source: string | undefined,
    showToast: boolean | undefined,
    toastType: string
  ): void {
    console.warn('logger service logIt');
    // Extract string message for display and logging
    const toastMessage =
      message instanceof Error ? message.message : typeof message === 'string' ? message : String(message);

    if (message instanceof Error) {
      if (this.appInsightsService) {
        this.appInsightsService.trackException(message, {
          props: {
            level: toastType,
            data: String(data ?? ''),
            source: source ?? '',
          },
        });
      }
    } else if (toastType === 'error' || toastType === 'warning') {
      if (this.appInsightsService) {
        this.appInsightsService.trackTrace(toastMessage, {
          props: {
            level: toastType,
            data: String(data ?? ''),
            source: source ?? '',
          },
        });
      }
    }
    console.debug('toast message is', toastMessage);
    this.logStorageService.storeLog(toastMessage, toastType, source ?? '');

    data = data || '';
    source = source || '';
    source = source ? '[' + source + '] ' : '';
    if (showToast) {
      this.snackBar.open(toastMessage, 'Dismiss', {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'bottom',
        panelClass: [`app-snack-${toastType}`],
      });
    }
  }
}
